<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增</el-button>
    <el-table ref="multipleTable" size="small" :data="list" style="width: 100%; margin-top:20px;">
      <el-table-column prop="id" label="投票ID" />
      <el-table-column prop="title" label="投票名称" />
      <el-table-column prop="status" label="投票状态">
        <template slot-scope="{row}">
          <el-tag v-show="row.status === 0" class="black-color" size="mini" disable-transitions>已发布</el-tag>
          <el-tag v-show="row.status === 1" class="golden-color" size="mini" disable-transitions>草稿</el-tag>
          <el-tag v-show="row.status === 2" class="red-color" size="mini" disable-transitions>进行中</el-tag>
          <el-tag v-show="row.status === 3" class="gray-color" size="mini" disable-transitions>已结束</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="投票日期" width="180px">
        <template v-slot="{row}">
          <span> {{ row.beginTime }} - {{ row.endTime }} </span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="操作" width="300px">
        <template v-slot="{row}">
          <el-button size="small" type="text" class="link-color" @click="edit(row)">编辑</el-button>
          <el-button size="small" type="text" class="link-color" @click="copy(row)">复制链接</el-button>
          <el-button size="small" type="text" class="link-color" @click="remove(row)">删除</el-button>
          <el-button v-if="row.status === 1" size="small" type="text" class="link-color" @click="publish(row)">发布</el-button>
          <el-button v-if="row.status !== 1" size="small" type="text" class="link-color" @click="undercarriage(row)">下架</el-button>
          <el-button size="small" type="text" class="link-color" @click="download(row)">投票结果</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background class="fixed-below" :page-size="pageSize" layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50, 100]" :current-page.sync="pageNum" :total="total" @size-change="handleSizeChange" @current-change="getList" />
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSucces" />
  </div>
</template>
<script>
import tableList from '@/components/TableList';
import moment from 'moment';
import Dialog from '@/components/Dialog';
export default {
  components: { tableList, Dialog },
  data() {
    return {
      formDialogShow: false,
      currentID: '',
      information: {},
      pageSize: 10,
      pageNum: 1,
      total: 0,
      list: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    formatTime(val) {
      if (val) return moment(val).format('YYYY/MM/DD HH:mm:ss');
      return '';
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    getList() {
      this.$Api.voteConfig.postVoteVoteList({
        limit: this.pageSize,
        current: this.pageNum,
      }).then(({ data, total }) => {
        this.list = data;
        this.total = total;
      });
    },
    add() {
      this.$router.push({ path: '/voteConfig/add' });
    },
    copy(row) {
      navigator.clipboard.writeText(`/pages-activity/user-cast-vote/index?id=${row.id}`).then(() => {
        this.$message.success('复制成功');
      }).catch(() => {
        this.$message.error('复制失败');
      });
      // this.formDialogShow = true;
      // this.currentID = row.id;
      // this.information = {
      //     operation: 'copy',
      //     icon: 'success',
      //     subTitle: `复制成功！是否进入新增页面？`,
      // };
    },
    edit(row) {
      this.$router.push({
        path: '/voteConfig/edit',
        query: {
          id: row.id,
        },
      });
    },
    remove(row) {
      this.currentID = row.id;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: `删除后小程序用户将无法查看该活动，请确认是否删除`,
      };
      this.formDialogShow = true;
    },
    download(row) {
      this.$Api.voteConfig.voteExportList(row.id).then((res) => {
        if (!res) {
          // this.$message.error('该训练营暂无报名人员');
        } else {
          this.$message.success('导出成功');
        }
      });
    },
    publish(row) {
      this.currentID = row.id;
      this.information = {
        operation: 'publish',
        icon: 'warn',
        subTitle: `是否确认发布活动ID为“${this.currentID}”的数据项？`,
      };
      this.formDialogShow = true;
    },
    undercarriage(row) {
      this.$Api.voteConfig.votesoldOut(row.id).then(() => {
        this.$message.success('下架成功');
        this.getList();
      });
    },
    submitSucces(operation) {
      if (operation === 'delete') {
        this.$Api.voteConfig.voteDelete(this.currentID).then(() => {
          this.$message.success('删除成功');
          this.pageNum = (this.pageNum -= this.list.length === 1 && 1) ? 1 : this.pageNum;
          this.getList();
        });
      } else if (operation === 'copy') {
        this.$router.push({ path: '/voteConfig/add', query: { copyid: this.currentID } });
      } else if (operation === 'publish') {
        this.$Api.voteConfig.votePublish(this.currentID).then(() => {
          this.$message.success('发布成功');
          this.pageNum = (this.pageNum -= this.list.length === 1 && 1) ? 1 : this.pageNum;
          this.getList();
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.golden-color,
.red-color,
.green-color,
.black-color {
  display: inline-block;
  min-width: 80px;
  height: 22px;
  line-height: 24px;
  // padding: 0 13px;
  text-align: center;
  line-height: 22px;
}
.gray-color {
  background: rgba(73, 73, 73, 0.1);
  border: 1px solid rgba(155, 155, 155, 0.7);
  font-family: Noto Sans SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #9b9b9b;
}
.golden-color {
  // padding: 1px 13px;
  background: rgba(234, 153, 33, 0.1);
  border: 1px solid rgba(234, 153, 33, 0.7);
  font-family: Noto Sans SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #ea9921;
}
.red-color {
  // padding: 1px 13px;
  background: rgba(220, 0, 25, 0.1);
  border: 1px solid rgba(220, 0, 25, 0.7);
  font-family: Noto Sans SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #dc0019;
}
.green-color {
  // padding: 1px 13px;
  background-color: #f0f9eb;
  border-color: #e1f3d8;
  color: #67c23a;
  font-family: Noto Sans SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
}
</style>
